import { useEffect, useState } from 'react';

interface CustomerLiveClock {
  time: string;
  date: string;
  greeting: string;
}

function computeGreeting(hour: number): string {
  if (hour < 5) return 'Good evening';
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

function compute(): CustomerLiveClock {
  const now = new Date();
  return {
    time: now.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' }),
    date: now.toLocaleDateString(undefined, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    }),
    greeting: computeGreeting(now.getHours()),
  };
}

/** Client-side only — local date/time/greeting, no API call, no schema dependency. */
export function useCustomerLiveClock(): CustomerLiveClock {
  const [clock, setClock] = useState<CustomerLiveClock>(compute);

  useEffect(() => {
    const timer = setInterval(() => setClock(compute()), 1000 * 30);
    return () => clearInterval(timer);
  }, []);

  return clock;
}
